<h1 class="ap-blue">{{'ml_144084' | translate}}</h1>

@if(!(commonDataLoading$ | async)) {
<app-smart-search-form [defaultSearchCriteria$]="defaultSearchCriteria$" [formPath]="formPath" [searchByList]="safetySearchByList$ | async" [onSearch]="onSearch"
  [searching$]="searching$"></app-smart-search-form>
}

@if(!(commonDataLoading$ | async)) {
<div class="row ms-0 mb-2">
  <div class="col p-0">
    <button (click)="onEdit()" [disableEditButton]="selectedItems" class="button--default">{{ 'ml_143925' | translate }}</button>
  </div>
</div>
}

<app-message-data [errorMsg$]="errorMessage$"></app-message-data>

<app-data-grid [isServerSidePagingFiltering]="true" [onLoadServerSideData]="onGetData" [totalCountForServerSidePagingFiltering$]="totalCount$"
  [isLoading]="(searching$ | async) || (commonDataLoading$ | async)" [dataSource$]="dataSource$" [defaultPageFilterSetting]="currentPageFilterSetting$ | async" [columnsDef]="dataGridColumnDef"
  [enableRowSelect]="true" (rowSelected)="rowSelected($event)">
  <ng-template #cellContent let-data="data" let-column="column">
    <app-safety-data-grid-cell [data]="data" [field]="column.name" [column]="column"></app-safety-data-grid-cell>
  </ng-template>
</app-data-grid>
